import { TAGS, api } from "@/store/api.ts"
import { IPaginationReq } from "@/types"
import {
  CARD_SKIN_TYPES,
  ICardBack,
  ICardBackActive,
  ICardBackPresence
} from "."

const basePath = "/card-backs"

export const cardBacksApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.CARD_BACKS]
})

export const cardBacksEndpoints = cardBacksApi.injectEndpoints({
  endpoints: (builder) => ({
    getCardBacksPresence: builder.query<ICardBackPresence, void>({
      query: () => ({
        url: `${basePath}/presence`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.CARD_BACKS, id: "PRESENCE" }]
    }),
    getCardBacksInstances: builder.query<unknown, IPaginationReq>({
      query: (params) => ({
        url: `${basePath}/instances`,
        method: "GET",
        params
      }),
      providesTags: () => [{ type: TAGS.CARD_BACKS, id: "INSTANCES" }]
    }),
    getCardBackActive: builder.query<ICardBackActive, void>({
      query: () => ({
        url: `${basePath}/active`,
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.CARD_BACKS, id: "ACTIVE" }]
    }),
    getCardBackActiveByPlayerId: builder.query<ICardBackActive, string>({
      query: (playerId) => ({
        url: `${basePath}/active/${playerId}`,
        method: "GET"
      }),
      providesTags: (_, __, playerId) => [
        { type: TAGS.CARD_BACKS, id: `ACTIVE:${playerId}` }
      ]
    }),
    getCardBackTemplateByType: builder.query<ICardBack, CARD_SKIN_TYPES>({
      query: (type) => ({
        url: `${basePath}/template/${type}`,
        method: "GET"
      }),
      providesTags: (_, __, type) => [
        { type: TAGS.CARD_BACKS, id: "TEMPLATE" },
        { type: TAGS.CARD_BACKS, id: `TEMPLATE:${type}` }
      ]
    }),
    activateCardBackByTemplateId: builder.mutation<
      ICardBack,
      {
        templateId: string
        card: ICardBack
      }
    >({
      query: ({ templateId }) => ({
        url: `${basePath}/template/${templateId}/activate`,
        method: "PATCH"
      }),
      onQueryStarted: async ({ card }, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled
          dispatch(
            cardBacksEndpoints.util.updateQueryData(
              "getCardBackActive",
              undefined,
              (draft) => {
                draft.cardBack = card
              }
            )
          )
        } catch {
          // ignore
        }
      }
    }),
    activateCardBackByInstanceId: builder.mutation<unknown, string>({
      query: (instanceId) => ({
        url: `${basePath}/instance/${instanceId}/activate`,
        method: "PATCH"
      }),
      invalidatesTags: () => [{ type: TAGS.CARD_BACKS, id: "ACTIVE" }]
    })
  })
})

export const {
  useGetCardBacksPresenceQuery,
  useActivateCardBackByInstanceIdMutation,
  useActivateCardBackByTemplateIdMutation,
  useGetCardBackActiveQuery,
  useGetCardBackTemplateByTypeQuery,
  useGetCardBacksInstancesQuery,
  useGetCardBackActiveByPlayerIdQuery
} = cardBacksEndpoints
